(() => {
  const sections = Array.from(document.querySelectorAll('.shopify-section'));
  if (!sections.length) return;

  const isHomePage = document.body.classList.contains('template-index');
  const viewportHeight = Math.max(window.innerHeight || 0, 640);
  let highPriorityImages = 0;

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    const isNearViewport = rect.top < viewportHeight * 1.25 && rect.bottom > -100;
    const hasFloatingUi = Boolean(
      section.querySelector('.m-sticky-addtocart, sticky-atc, [data-tr-sticky-atc]')
    );

    if (isHomePage && !isNearViewport && !hasFloatingUi) {
      section.classList.add('tr-defer-section');
    } else {
      section.classList.remove('tr-defer-section');
    }

    const images = Array.from(section.querySelectorAll('img'));
    images.forEach((img) => {
      img.decoding = 'async';

      const imageRect = img.getBoundingClientRect();
      const isVisibleCandidate = imageRect.width > 0 && imageRect.height > 0;

      if (isNearViewport && isVisibleCandidate && highPriorityImages < 2) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
        highPriorityImages += 1;
      } else if (!isNearViewport) {
        img.loading = 'lazy';
        img.fetchPriority = 'low';
      }
    });

    const videos = Array.from(section.querySelectorAll('video'));
    videos.forEach((video) => {
      if (!isNearViewport) video.preload = 'metadata';
    });
  });
})();
